import React, {useMemo} from 'react';
import {useTheme} from '@mui/material/styles';

/**
 * Sélecteur de typologie — variante "1b" du handoff FormNewOrEdit v2 :
 * chips pill groupées sous eyebrows « Bacs & abris » / « Colonnes & PAV ».
 * Chip sélectionnée = couleur BDD de la typologie (identique au badge mobile),
 * non sélectionnée = pill neutre avec pastille de couleur.
 *
 * Le groupement est une heuristique d'affichage sur le libellé (la typologie
 * ne porte pas de type de conteneur en BDD) : COLONNE / PAV → 2e groupe.
 */

const GROUP_BACS = 'Bacs & abris';
const GROUP_COLONNES = 'Colonnes & PAV';

function groupOf(typologie) {
    const l = (typologie?.libelle || '').toUpperCase();
    return (l.includes('COLONNE') || l.includes('PAV')) ? GROUP_COLONNES : GROUP_BACS;
}

function TypologieChip({typologie, selected, onClick}) {
    const theme = useTheme();
    const couleur = typologie.couleur || '#213067';
    return (
        <span
            onClick={onClick}
            style={{
                display: 'inline-flex', alignItems: 'center', gap: 7,
                padding: '7px 14px', borderRadius: 999, fontSize: 13, fontWeight: 600,
                lineHeight: 1.2, cursor: 'pointer', userSelect: 'none',
                // Bordure 1px pleine (pas de demi-pixel : rend flou hors écrans retina)
                // et transition ciblée (transition:all fait "baver" le texte).
                transition: 'background-color .2s, color .2s, border-color .2s, box-shadow .2s',
                background: selected ? couleur : '#F0F0F0',
                color: selected ? theme.palette.getContrastText(couleur) : '#5A6470',
                border: selected ? '1px solid transparent' : '1px solid #E3E7EC',
                boxShadow: selected ? '0 2px 6px rgba(33,48,103,.25)' : 'none',
            }}
        >
            {!selected && (
                <span style={{width: 9, height: 9, borderRadius: '50%', background: couleur, flexShrink: 0}}/>
            )}
            {(typologie.libelle || '').toUpperCase()}
        </span>
    );
}

function TypologieLavageSelector({typologies, value, onChange}) {
    const groups = useMemo(() => {
        const g = {[GROUP_BACS]: [], [GROUP_COLONNES]: []};
        (typologies || []).forEach((t) => g[groupOf(t)].push(t));
        return Object.entries(g).filter(([, items]) => items.length > 0);
    }, [typologies]);

    if (!typologies || typologies.length === 0) return null;

    return (
        <div>
            {groups.map(([name, items]) => (
                <div key={name} style={{marginBottom: 10}}>
                    <div style={{fontSize: 11, fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', color: '#8A929C', marginBottom: 6}}>
                        {name}
                    </div>
                    <div style={{display: 'flex', flexWrap: 'wrap', gap: 8}}>
                        {items.map((t) => (
                            <TypologieChip
                                key={t['@id']}
                                typologie={t}
                                selected={value === t['@id']}
                                onClick={() => onChange(t['@id'])}
                            />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default TypologieLavageSelector;
